export class InfoEnregistrement {
    id:Number;
    totalPages : number;
    nombreEnreg : number;
    pageActu :number;
    limite : number;
    
}
